import React from 'react';
import { X, MessageSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

interface EditorChatPanelProps {
  isOpen: boolean;
  onClose: () => void;
  workbookId?: string;
  pageId?: string;
}

export function EditorChatPanel({
  isOpen,
  onClose,
  workbookId,
  pageId,
}: EditorChatPanelProps) {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/10 backdrop-blur-sm z-40 lg:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Chat Panel */}
      <div
        className={cn(
          "fixed top-0 right-0 h-full w-full sm:w-96 bg-white dark:bg-gray-900 shadow-2xl border-l border-gray-200 dark:border-gray-700 z-50",
          "transform transition-transform duration-300 ease-in-out",
          isOpen ? "translate-x-0" : "translate-x-full"
        )}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-blue-500" />
            <h3 className="font-semibold text-gray-900 dark:text-white">
              Editor Chat
            </h3>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-8 w-8 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        
        {/* Chat Content - Placeholder for now */}
        <div className="flex-1 p-4 space-y-4">
          <div className="text-center text-gray-500 dark:text-gray-400 py-8">
            <MessageSquare className="h-12 w-12 mx-auto mb-4 text-gray-300 dark:text-gray-600" />
            <p className="text-sm">Chat interface will be integrated here</p>
            {workbookId && (
              <p className="text-xs mt-2">
                Workbook: {workbookId}
                {pageId && <><br />Page: {pageId}</>}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
} 